/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Util} from "../Utilities.js";
import DateTime from "toolbox/dateTime";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import ElementStatus from "./ElementStatus.jsx";
import DisplayJson from "./DisplayJSON.jsx";

class DeploymentsManagement extends Component {
    constructor() {
        super();
        this.state = {
            allDeployments: []
        }
    }


    async fetchData() {
        let allDeployments = await Database.table("Deployments", "app").getData()
        let all = allDeployments.recordset.sort((a, b) => {
            const timeA = a.timestamp ?? 0;
            const timeB = b.timestamp ?? 0;
            return timeB - timeA;
        });

        this.setState({allDeployments: all})
    }

    componentDidMount() {
        this.fetchData()
    }


    async editDeployment(deployment) {

        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2 space-y-4"}>
                <OutputList>
                    <OutputListItem titel={"indexKey"}>
                        <span>{deployment.indexKey}</span>
                    </OutputListItem>

                    <OutputListItem titel={"objectType"}>
                        <span>{deployment.objectType}</span>
                    </OutputListItem>
                    <OutputListItem titel={"status"}>
                        <span>{deployment.status}</span>
                    </OutputListItem>
                    <OutputListItem titel={"phase"}>
                        <span>{deployment.phase}</span>
                    </OutputListItem>
                    <OutputListItem titel={"created"}>
                        <span>{deployment.timestamp ? DateTime.format(deployment.timestamp, "HH:mm dd.MM.yyyy") : ""}</span>
                    </OutputListItem>
                    <OutputListItem titel={"started"}>
                        <span>{deployment.startedTimestamp ? DateTime.format(deployment.startedTimestamp, "HH:mm dd.MM.yyyy") : ""}</span>
                    </OutputListItem>
                    <OutputListItem titel={"done"}>
                        <span>{deployment.doneTimestamp ? DateTime.format(deployment.doneTimestamp, "HH:mm dd.MM.yyyy") : ""}</span>
                    </OutputListItem>
                    <OutputListItem titel={"duration"}>
                        <span>{deployment.duration ? `${Math.round(deployment.duration)}s` : ""}</span>
                    </OutputListItem>
                    <OutputListItem titel={"SV"}>
                        <span>{deployment.SV}</span>
                    </OutputListItem>
                    <OutputListItem titel={"timestamp"}>
                        <span>{deployment.timestamp}</span>
                    </OutputListItem>
                    <OutputListItem titel={"lastChanged"}>
                        <span>{deployment.lastChanged}</span>
                    </OutputListItem>
                    <OutputListItem titel={"name"}>
                        <span>{deployment.userInput?.name}</span>
                    </OutputListItem>
                    <OutputListItem titel={"source"}>
                        <span>{deployment.userInput?.source}</span>
                    </OutputListItem>
                    <OutputListItem titel={"type"}>
                        <span>{deployment.userInput?.type}</span>
                    </OutputListItem>
                    <OutputListItem titel={"httpPort"}>
                        <span>{deployment.defaultsSet?.httpPort}</span>
                    </OutputListItem>
                </OutputList>

                <div>
                    <div className="text-sm font-medium text-gray-600 mb-1">userInput</div>
                    <DisplayJson jsonInput={deployment.userInput}/>
                </div>

                <div>
                    <div className="text-sm font-medium text-gray-600 mb-1">defaultsSet</div>
                    <DisplayJson jsonInput={deployment.defaultsSet}/>
                </div>

                {deployment.dockerFileContent && (
                    <div>
                        <div className="text-sm font-medium text-gray-600 mb-1">dockerFileContent</div>
                        <DisplayJson jsonInput={(deployment.dockerFileContent ?? "").split("\n")}/>
                    </div>
                )}

                <ButtonComponent
                    text={"Remove Deployment"}
                    onClick={async () => {
                        await Database.table("Deployments", "app").remove(deployment.indexKey)
                        await this.fetchData()
                        close()
                    }}/>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Deployment", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allDeployments} = this.state

        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Deployment"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Deployment"} elementId={row.indexKey}/>


                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allDeployments.map(item => ({
                        ...item,
                        Name: <>{item.indexKey} </>

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                     <ButtonComponent iconName={"IoAdd"}
                                                                      onClick={() => {
                                                                          //AppActions.layout.newLayout()
                                                                      }}
                                                                      text={`Neue  `}/>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editDeployment(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default DeploymentsManagement;
